import { TableColumn } from 'modules/shared-components/data-display/table/types';
import { Pagination } from 'api/types/httpsTypes';
import AssetIcon from 'modules/shared-components/asset/asset-icon';
import { DATE_FORMAT } from 'modules/marketplace-performance-page/constants/DATE_FORMAT';
import moment from 'moment';
import Big from 'big.js';

export interface Position {
  id: string;
  pair: { quote: string; base: string };
  returns: number;
  openTime: string;
  closeTime: string;
  exchange: { id: number; name: string; imgName: string };
}

export type ColumnProps = {
  pagination: Pagination;
  data: Position[];
  errors?: any[];
};

export const closedPositionsColumn: TableColumn<ColumnProps['data'][number]>[] =
  [
    {
      label: 'PAIR',
      key: 'pair',
      component: ({ data }) => (
        <div className="flex items-center space-x-2">
          <div>
            <AssetIcon imgName={data.pair.base} />
          </div>
          <div>
            <div>
              {data.pair.base}/{data.pair.quote}
            </div>
            <div className="text-xs">on {data.exchange.name}</div>
          </div>
        </div>
      ),
    },

    {
      label: 'PNL',
      key: 'pnl',
      component: ({ data }) => (
        <span
          className={
            data?.returns > 0 ? 'text-green-success' : 'text-red-warning'
          }
        >
          {data.returns > 0 && '+'}
          {Big(data?.returns).mul(100).toFixed(2)}%
        </span>
      ),
    },
    {
      label: 'OPEN TIME',
      key: 'openTime',
      component: ({ data }) => (
        <span>{moment(data.openTime).format(DATE_FORMAT)}</span>
      ),
    },
    {
      label: 'CLOSE TIME',
      key: 'CloseTime',
      component: ({ data }) => (
        <span>{moment(data.closeTime).format(DATE_FORMAT)}</span>
      ),
    },
  ];
